import React from "react";
import assetify from "@quintype/framework/assetify";
import bgimage from "../icons/content.png";
import bgimage2 from "../icons/content2.png";

import "./description.m.css";

const SupportDescriptionView = () => {
  const content1 = {
    title: "Special benefits for all subscriptions during the Independence day offer:",
    list: [
      "Special access to the Members room feature in our webinars.",
      "Behind The Scene webinar series-  with our senior journalist, Ms. Poonam Agarwal.",
      "Get the first month of BQ subscription free",
      "Get your opinion piece or article published on The Quint’s exclusive Members’ opinion section, every month.",
    ],
  };

  const content2 = {
    title: "Gamechangers get:",
    list: [
      "Get a premium, ad-free experience of The Quint, Quint Hindi, and FIT",
      "Stay updated with a daily newsletter curated with important stories on The Quint, Quint Hindi, and FIT",
      "Quick news updates with access to our exclusive Telegram group",
      "Get invited to our members-only events and webinars",
      "Join the conversation on our exclusive members-only Facebook group",
      "Enjoy early access to our premium content, and a behind-the-scenes look at what goes into doing a story",
      "Stay Informed with our weekly WebQoof round-up, important fact-checked stories delivered to your inbox.",
    ],
  };

  const content3 = {
    title: "Leaders get:",
    list: [
      "Get every privilege offered to the Gamechangers +",
      "Members Opinion Newsletter- Monthly Special (Your opinion piece delivered to our member’s inbox)",
    ],
  };

  const content4 = {
    title: "Ambassadors get:",
    list: [
      "Get every privilege offered to the Leaders and Gamechangers +",
      "Get your opinion piece or article published on The Quint’s exclusive Members’ Opinion section, every month.",
      "Signed Copy of Super Century: What India Must Do to Rise by 2050 by Mr. Raghav Bahl",
    ],
  };

  const getView = (data, image) => (
    <div styleName="content" className="container" style={{ backgroundImage: `url(${assetify(image)})` }}>
      <div styleName="title">{data.title}</div>

      <ul styleName="list-items">
        {data.list.map((value, index) => (
          <li key={index}>{value}</li>
        ))}
      </ul>
    </div>
  );

  return (
    <div styleName="wrapper">
      <div styleName="row1">{getView(content1, bgimage)}</div>
      <div styleName="row2">
        <div>{getView(content2, bgimage2)}</div>
        <div styleName="row3">
          {getView(content3, bgimage)}
          {getView(content4, bgimage2)}
        </div>
      </div>
    </div>
  );
};

export default SupportDescriptionView;
